<template>
  <div
    class="background w100"
    :style="[
      { 'background-color': $route.name === 'search' ? '#EBF0F1' : 'white' },
    ]"
  >
    <Navbar />
    <div id="router-view">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <div class="contactWidgetContainer">
      <ContactFull class="contactWidget" />
    </div>
    <Footer />
  </div>
</template>

<script>
// import BurgerMenu from "@/components/molecules/BurgerMenu.vue";

import Navbar from "@/components/organisms/Navbar.vue";
import Footer from "@/components/organisms/Footer.vue";
import ContactFull from "@/components/organisms/ContactFull.vue";
// import CoronaNotif from "@/components/atoms/CoronaNotif.vue";

import { mapActions, mapMutations } from "vuex";
export default {
  name: "app",
  components: {
    // BurgerMenu,
    Navbar,
    Footer,
    ContactFull,
    // CoronaNotif,
  },
  data(){
    return {
      isCovidNotifOpen: true,
    }
  },
  methods: {
    ...mapMutations([
      "storeGyms",
      "storeSearch",
      "storePageNumber",
      "storeRange",
      "setFacilities",
      "storeFacilities",
    ]),
    ...mapActions(["findGyms", "findAllGyms"]),
    async getDataOnLoad() {
      if (this.$route.name === "search") {
        this.storeRange(this.$route.params.range);
        this.storeFacilities(this.$route.query.facilities);
        this.storePageNumber(this.$route.query.page);
        if (this.$route.query.search) {
          this.storeSearch(this.$route.query.search.split("-").join(""));
          this.storeRange(this.$route.params.range);
          await this.findGyms();
        }
      }
    }
  },
  watch: {
    $route() {
      this.getDataOnLoad();
    }
  },
  async mounted() {
    this.isCovidNotifOpen = localStorage.getItem('isCovidNotifOpen') || 'true'

    const response = await this.$http.get("/api/facilities");
    let facilities = response.data.map((item) => {
      return { ...item, selected: false };
    });

    this.setFacilities(facilities);
    this.getDataOnLoad();
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 770px) {
  body {
    overflow-x: hidden;
  }
}

.shadow {
  position: absolute;
  width: 100%;
  height: 2rem;
  box-shadow: inset 0px 5px 10px -8px #000000;
  left: 0;
}

.contactWidgetContainer {
  position: sticky;
  z-index: 100;
  bottom: 0rem;
  right: 0rem;
  text-align: center;
}

@media (max-width: 768px) {
  .contactWidgetContainer {
    bottom: 3rem !important;
  }
}


.contactWidget {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  float: right;
}

@media (max-width: 600px) {
  .contactWidget {
    bottom: 3rem;
    right: 2rem;
  }
}

.over-wrapper {
  min-height: 100vh;
  width: 100%; 
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
